module.exports = __webpack_public_path__ + "static/bigby_s_hand-3606a8969e1c99750e0430bfc03843a7.webp";